import type { UserConfig } from '@/entities/user-config';
import { updateUserConfig } from '@/entities/user-config';
import isHumanMessage from '@/features/ai-chat/lib/isHumanMessage';
import type { Conversation, Message } from '@/features/ai-chat/types/chat.types';

const MAX_HISTORY = 10;

export const deriveConversationName = (messages: Message[]) => {
  const firstHuman = messages.find(m => isHumanMessage(m)) as
    | (Message & { sender: 'human'; text: string })
    | undefined;
  const text = (firstHuman?.text || '').trim();
  if (!text) return '...';
  return text;
};

interface SaveUserHistoryParams {
  userConfig: UserConfig;
  saveUser: (config: UserConfig) => void;
  updatedConversation: Conversation;
  existing: Conversation[];
  idx: number;
}

export default function saveUserHistory({
  userConfig,
  saveUser,
  updatedConversation,
  existing,
  idx
}: SaveUserHistoryParams) {
  const ensuredName =
    updatedConversation.name || deriveConversationName(updatedConversation.messages);

  const withName: Conversation = { ...updatedConversation, name: ensuredName };

  const chatHistory =
    idx >= 0
      ? [...existing.slice(0, idx), withName, ...existing.slice(idx + 1)]
      : [withName, ...existing];
  const limited = chatHistory.slice(0, MAX_HISTORY);
  saveUser(updateUserConfig(userConfig, { chatHistory: limited }));
}
